import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MailCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { AuthCard, AuthMessage, authInputCls, authButtonCls, authLabelCls } from "./components/AuthCard";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setSent(r.data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard
      testid="forgot-password-card"
      title="Reset PIN or Password"
      subtitle={sent ? "" : "Enter the email address for your admin account and we'll send you a secure link to choose a new PIN (and a new password if you need one)."}
    >
      {sent ? (
        <div className="space-y-5" data-testid="forgot-password-sent">
          <div className="flex items-start gap-3 rounded-2xl bg-white border border-sand p-4">
            <span className="w-10 h-10 shrink-0 rounded-full bg-gold-light border border-sand flex items-center justify-center">
              <MailCheck className="w-5 h-5 text-gold" strokeWidth={2.2} />
            </span>
            <p className="text-sm text-navy leading-relaxed" data-testid="forgot-password-message">{sent}</p>
          </div>
          <p className="text-xs text-slate-500">Didn't get it? Check your spam folder, or come back here to request another link.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
          <div>
            <label className={authLabelCls} htmlFor="fp-email">Admin email</label>
            <input id="fp-email" type="email" required data-testid="forgot-password-email-input" className={authInputCls} value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
          </div>
          {error && <AuthMessage testid="forgot-password-error">{error}</AuthMessage>}
          <button type="submit" disabled={loading} data-testid="forgot-password-submit" className={authButtonCls}>
            {loading ? "SENDING…" : "SEND RESET LINK"}
          </button>
        </form>
      )}
      <Link to="/admin/login" data-testid="back-to-login-link" className="mt-6 inline-flex items-center gap-1.5 py-1.5 text-sm font-semibold text-navy hover:text-gold transition-colors">
        <ArrowLeft className="w-4 h-4" /> Back to Sign In
      </Link>
    </AuthCard>
  );
}
